<template>
  <div class="dx-card-manage-filters">
    <form @submit.prevent="onSubmit" class="form-inline">
      <div class="input-group">
        <input ref="input" type="text" class="form-control" v-model="model.search">
        <div class="input-group-append">
          <dx-button primary type="submit" :loading="disabled" :disabled="disabled">
            {{ $t('search') }}
          </dx-button>
          <dx-button link @click.native="cleanFilters" v-if="filtered">
            {{ $t('cleanFilters') }}
          </dx-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {
  DxButton
} from '../components'
export default {
  name: 'dx-card-manage-filters',
  components: {
    DxButton
  },
  props: {
    disabled: false
  },
  data () {
    return {
      model: {
        search: ''
      },
      filtered: false,
      lastSearch: ''
    }
  },
  methods: {
    onSubmit () {
      if (this.model.search !== this.lastSearch) {
        this.lastSearch = this.model.search
        this.$emit('filters', this.model)
      } else {
        this.$refs.input.focus()
      }
      if (this.model.search !== '') {
        this.filtered = true
      } else {
        this.filtered = false
      }
    },
    cleanFilters () {
      this.filtered = false
      this.model.search = ''
      this.lastSearch = ''
      this.$emit('filters', this.model)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxCardManageFilters.vue